import { type QueryClient } from '@tanstack/react-query';

import { bankAccountDropdownBaseQueryKey } from '../bankAccounts/bankAccountDropdownQueryKey';

import { loanDropdownBaseQueryKey, loanQueryKey } from './loanQueryKeys';

// Payments and disbursements move both the loan's and the bank account's balances.
export const invalidateLoanBalances = (queryClient: QueryClient, loanId: string) =>
  Promise.all(
    [loanQueryKey(loanId), loanDropdownBaseQueryKey, bankAccountDropdownBaseQueryKey].map((queryKey) =>
      queryClient.invalidateQueries({ queryKey })
    )
  );
